<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee-nofooter">
            <div class="text-center">
                <img
                    class="wrapper_title_logo"
                    src="@/assets/home/logo-new-theme.png"
                />
            </div>
            <div>
                <div class="wrapper__profile">
                    <Profile />
                </div>
            </div>
            <!--  -->
            <div class="voucher-container">
                <div class="col-12 title-voucher">Voucher</div>
                <div id="voucher-campaignlist-list">
                    <!-- <category-slider
                        class="d-none"
                        :locale="locale"
                        :categoryConfig="categoryConfig"
                        :busEvent="busCategory"
                        @changeCategory="changeCategory($event)"
                    >
                    </category-slider> -->
                    <campaign-list
                        ref="campaignlist"
                        :lbl="lbl"
                        :isLoading="isLoading"
                        :initListConfig="campaignListConfig"
                        :initFilterConfig="campaginListFilterConfig"
                        :busEvent="busCategory"
                        :isslide="false"
                        :square="true"
                        :isClickCampaign="true"
                        @toggleLoading="toggleLoading($event)"
                    >
                    </campaign-list>
                </div>
            </div>
        </div>
        <Footer :settabactive="'voucher'" />
    </div>
</template>
<script>
import Vue from "vue";
// helper
import Locale from "@/helper/locale/locale.js";
// core
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder,
} from "@/core/Campaign/model/CampaignConfigModel.js";
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";
import ConfigManager from "@/config/ConfigManager.js";
// component
import Profile from "@/module/List/component/Profile.vue";
import CampaignList from "@/module/List/component/CampaignList.vue";
import Footer from "@/components/Footer/Footer.vue";
import CheckLogin from "@/mixin/CheckLogin.js";
import CacheHelper from "@/helper/CacheHelper.js";
// import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import Mixin from "@/mixin/Mixin";
//vuex
import { mapGetters } from "vuex";

export default {
    name: "Category",
    components: {
        CampaignList,
        Footer,
        Profile,
    },
    mixins: [Mixin, CheckLogin],
    computed: mapGetters(["getUserlevel"]),
    data: function () {
        return {
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),
            isLoading: false,
            //config
            categoryConfig: {},
            campaignListConfig: {},
            campaginListFilterConfig: {},
            //bus
            busCategory: new Vue(),
            tab: "rewards",
            pdpaTermVersion: {},
            cacheHelper: new CacheHelper(),
            consent: {},
            tokenbzbs: null,
            line_image: null,
            profile: {},
        };
    },
    watch: {
        activeTab: function (newItem) {
            this.clickTab(newItem);
        },
    },
    mounted() {
        var cacheHelper = new CacheHelper("cookie");
        this.tokenbzbs = cacheHelper.getCache("BzbsUser").token;
    },
    created: async function () {
        this.handleLoading(true);
        this.line_image = this.cacheHelper.getCache("BzbsUser").line.pictureUrl;
        await this.initialCampaign();
        await this.getProfile();
        Promise.all([
            this.getProfile(),
            this.initialCategory(),
            this.initialCampaign(),
        ]).then(() => {
            this.$refs.campaignlist.getList().then(() => {
                this.handleLoading(false);
            });
        });
    },
    methods: {
        // getProfile() {
        //     return new Promise(resolve => {
        //         BzbsApi.getProfile(
        //             this.cacheHelper.getCache("BzbsUser").token
        //         ).then(response => {
        //             this.profile = response.data;
        //             resolve(this.profile);
        //         });
        //     });
        // },
        numberWithCommas(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (x == 0) {
                return 0;
            } else {
                return "-";
            }
        },
        changeCategory(category) {
            this.handleLoading(true);
            this.initialCampaign(category).then(() => {
                this.handleLoading(false);
            });
        },
        initialCategory() {
            return new Promise((resolve) => {
                var configStr = ConfigManager.getCategoryMenu();
                var categoryConfig = new CategoryConfigBuilder()
                    .setConfig(configStr)
                    .setLocale(this.locale);

                this.categoryConfig = categoryConfig.create();
                resolve(this.categoryConfig);
            });
        },
        initialCampaign() {
            return new Promise((resolve) => {
                this.campaignListConfig = {};
                this.campaginListFilterConfig = {};

                var listConfig = new CampaignListConfigBuilder()
                    .setConfigList("campaign_nescafestreetcafe_privilege")
                    .setTop(25);

                // if (category.id) listConfig.setCatId(category.id);

                this.campaignListConfig = listConfig.create();

                var filterConfig = new CampaignListFilterConfigBuilder();
                this.campaginListFilterConfig = filterConfig.create();

                this.busCategory.$emit("reInitList", {
                    listConfig: this.campaignListConfig,
                    filterConfig: this.campaginListFilterConfig,
                });
                resolve(this.campaginListFilterConfig);
            });
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
        clickTab: function (tab) {
            this.tab = tab;
            this.$emit("clickTab", this.tab);
        },
    },
};
</script>
<style lang="scss">
@import "@/style/_mixin.scss";
.voucher-container {
    margin-top: 20px;
}
.not-campaign {
    font-size: 16px;
}
.position-btn-close-regis {
    z-index: 2;
    position: absolute;
    // top: 50%;
    left: 6%;
    transform: translate(0%, -100%);
}
.position-img-blur {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 0;
}
.wrapper__profile {
    height: 20px;
    width: auto;
    min-height: 100px;
    background: #fff;
    border-radius: 15px;
    margin: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .status {
        width: auto;
        height: 16px;
        margin-top: 15px;
    }
    .wrapper__point {
        background-color: white;
        color: #a7907b;
        .icon {
            width: 18px;
            margin-left: 8px;
        }
        text-align: center;
        border-radius: 15px;
        font-size: 18px;
        font-weight: bold;
    }
    .wrapper__unit {
        background-color: white;
        color: #a7907b;
        .icon {
            width: 18px;
            margin-left: 8px;
        }
        text-align: center;
        border-radius: 15px;
        font-size: 18px;
        font-weight: bold;
    }
}
.profile__image {
    width: 60px;
    height: 60px;
    border-radius: 45px;
    position: absolute;
    z-index: 1;
    top: 15px;
    left: 30px;
    border: solid 3px #978370;
}
.banner {
    width: 100%;
}
.title-voucher {
    color: $color-text;
    font-size: 16px;
    font-family: "PromptSemiBold";
}
</style>
